<template>
  <BaseModal
    small
    :heading="$t('marketing.email.variables-modal.heading')"
    :loading="loading"
    @close="$emit('close')"
  >
    <BaseText mb>{{ $t('marketing.email.variables-modal.info') }}</BaseText>
    <BaseText
      mb
      bold
    >
      {{ $t('marketing.email.variables-modal.what_you_can_use') }}
    </BaseText>
    <Variables :variables="variables" />
    <template #footer>
      <BaseButton @click="$emit('close')">
        {{ $t('global.actions.close') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import Variables from './Variables.vue';

defineEmits(['close']);

defineProps<{
  loading?: boolean;
  variables: string[];
}>();
</script>
